import { when } from "mobx";
import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { FulfillmentSettingsTracking, t, Tracking, translate, } from "restaumatic-client";
import Alert from "../../components/Alert";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import CrossSellingList from "../../components/CrossSellingList";
import FulfillmentMethodForm from "../../components/FulfillmentMethodForm";
import FulfillmentTimeBlock from "../../components/FulfillmentTimeBlock";
import { showModal, switchModals } from "../../utils/Modals";
import FulfillmentTimeModal from "../Menu/FulfillmentTimeModal";
import CartProducts from "./CartProducts";
import CartPromotions from "./CartPromotions";
import CartSummaryRows from "./CartSummaryRows";
import { CART_MODAL_ID } from "./init";
function CartBody(props) {
    const { cart, onChangeRestaurant } = props;
    const { fulfillmentFormController, fulfillmentTime } = cart;
    const crossSellingItems = cart.crossSellingCreator.items.raw;
    const isImageVisible = Boolean(Number(Skubacz.configuration.theme_settings.cart_dish_images));
    const imageType = window.Skubacz.configuration.theme_settings.dish_image_style ===
        "rounded-circle"
        ? "circle"
        : "square";
    useEffect(() => {
        return when(() => { var _a; return ((_a = cart.error) === null || _a === void 0 ? void 0 : _a.type) == "NotOverlappingDishes"; }, () => {
            Tracking.trackEvent({
                tag: "NotOverlappingDishes",
                contents: {
                    action: "not_overlapping_delivery_times_message",
                    category: "cart",
                    label: cart.restaurantName,
                },
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (h(Fragment, null,
        cart.orderingHoursMessage !== null && (h(Alert, { type: cart.orderingHoursMessage.level, message: cart.orderingHoursMessage.message, fieldId: "cart.error" })),
        h("div", { class: "u-childs-separator" },
            h(CartProducts, { mode: "editable", items: cart.orderLines, isImageVisible: isImageVisible, imageType: imageType }),
            h(CartPromotions, { fodState: cart.fodState, fodController: cart.fodFormController, promotions: cart.promotions, couponState: cart.couponState, cartMeetsCouponPromotionConditions: cart.cartMeetsCouponPromotionConditions }),
            fulfillmentFormController.isFulfillmentEditable &&
                cart.orderDetails.isFulfillmentEditable && (h(CartFulfillmentSettings, { fulfillmentFormController: fulfillmentFormController, fulfillmentMethodsOptions: cart.fulfillmentMethodsOptions, fulfillmentTime: fulfillmentTime, orderDetails: cart.orderDetails, deliveryAddressCoordinator: cart.deliveryAddressCoordinator, onChangeRestaurant: onChangeRestaurant }))),
        cart.error !== null && (h(Alert, { type: cart.error.level, message: cart.error.message, fieldId: "cart.error" })),
        h(AvailabilityDebugInfo, { name: "Cart", fieldId: "cart", availability: cart.availability }),
        h(CartSummaryRows, { deliveryPrice: cart.deliveryPrice, packagingPrice: cart.packagingPrice }),
        crossSellingItems.length > 0 && (h(CrossSellingList, { fieldId: "cart.crossSelling", items: crossSellingItems }))));
}
// TODO: DRY with Checkout.tsx
const CartFulfillmentSettings = observer((props) => {
    const { fulfillmentFormController, fulfillmentMethodsOptions, fulfillmentTime, orderDetails, deliveryAddressCoordinator, onChangeRestaurant, } = props;
    const fulfillmentTimeModalId = "cart-time";
    const editTimeBtnRef = useRef(null);
    const handleTimeModalOpen = () => void switchModals(CART_MODAL_ID, fulfillmentTimeModalId);
    const handleTimeSubmit = () => {
        FulfillmentSettingsTracking.chooseDateEvent({ tag: "Cart" });
    };
    const handleTimeModalHidden = () => {
        var _a;
        void showModal(CART_MODAL_ID);
        (_a = editTimeBtnRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (h("form", { class: "delivery is-editing" },
        h("h5", null, translate(t.orders.form.fulfillment_options)),
        fulfillmentTime.isVisible && (h(Fragment, null,
            h(FulfillmentTimeBlock, { fulfillmentTime: fulfillmentTime, isRequired: false, editBtnRef: editTimeBtnRef, onEdit: handleTimeModalOpen }),
            h(FulfillmentTimeModal, { id: fulfillmentTimeModalId, dataFieldId: "Cart.fulfillmentTimeModal", modal: fulfillmentTime.modal, onShow: () => fulfillmentTime.touch(), onSubmit: handleTimeSubmit, onHidden: handleTimeModalHidden }))),
        h(FulfillmentMethodForm, { orderDetails: orderDetails, deliveryAddressCoordinator: deliveryAddressCoordinator, options: fulfillmentMethodsOptions, controller: fulfillmentFormController.fulfillmentMethodController, withApartmentInfo: false, withHiddenNoContactDelivery: false, onChangeRestaurant: onChangeRestaurant, origin: "Cart", viewType: "Cart" })));
});
export default observer(CartBody);
